import {createSlice} from '@reduxjs/toolkit';
import {sendInquiry} from '../actions/inquiry';

const initialState = {
    success: false,
    isLoading: false,
    hasError: false,
    errorMessage: '',
};

const inquirySlice = createSlice({
    name: 'inquiry',
    initialState,
    reducers: {
        resetInquiry: () => initialState,
    },
    extraReducers(builder) {
        builder
            .addCase(sendInquiry.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(sendInquiry.fulfilled, (state, action) => {
                state.isLoading = false;
                state.success = true;
            })
            .addCase(sendInquiry.rejected, (state, action) => {
                state.isLoading = false;
                state.success = false;
                state.hasError = true;
                state.errorMessage = action.payload.errorMessage;
            });
    },
});

export const {resetInquiry} = inquirySlice.actions;
export default inquirySlice.reducer;
